import { useScroll, useSpring, motion } from 'framer-motion';

const ScrollProgressBar = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '3px',
        zIndex: 9999,
        background: 'linear-gradient(90deg, #6366f1, #8b5cf6, #a78bfa)',
        transformOrigin: '0%',
        scaleX,
        pointerEvents: 'none',
      }}
    />
  );
};

export default ScrollProgressBar;
